module.exports = __webpack_public_path__ + "europa-200_emerald_number.jpg?bc880abf30f1d31f589b66beadf2e863";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-200_emerald_number.jpg
// module id = 317
// module chunks = 0